import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { COUNTRIES } from "../data/content";

export default function CountryCombobox({ value, onChange, placeholder = "Select your country", testIdPrefix = "country" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid={`${testIdPrefix}-trigger`}
          className="flex h-11 w-full items-center justify-between rounded-xl border border-[color:var(--hairline)] bg-[color:var(--surface)] px-3.5 text-sm text-[color:var(--ink)] transition-colors hover:border-[color:var(--ink)]">
          <span className={value ? "" : "text-[color:var(--ink-soft)]"}>{value || placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search country..." data-testid={`${testIdPrefix}-search`} />
          <CommandList>
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {COUNTRIES.map((c) => (
                <CommandItem key={c} value={c} onSelect={() => { onChange(c); setOpen(false); }} data-testid={`${testIdPrefix}-option-${c}`}>
                  <Check className={`mr-2 h-4 w-4 ${value === c ? "opacity-100" : "opacity-0"}`} />{c}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
